import * as React from 'react';
import styled, { css } from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { IPopupProps } from '../popup-props';
import { Typography } from '../../typography';
import { PlainButton } from '../../button';
import { Icon } from '../../icon';

interface IPopupHeaderProps extends IBaseComponentProps<HTMLDivElement>, Pick<IPopupProps, 'title' | 'onRenderTitle' | 'titleAlignment'> {
    hideCloseButton?: boolean;
    onCloseClick(): void;
}

const Title = styled(Typography.Large).attrs({
    className: String('ap-popup-title')
}) <Pick<IPopupProps, 'titleAlignment'>>`
    display: inline-block;
    width: calc(100% - 40px);
    color: ${({ theme: { popup: { colors } } }) => colors.popupTitleColor};
    ${({ titleAlignment }) => titleAlignment && css`text-align: ${titleAlignment};`}
`;

const CloseAction = styled(PlainButton).attrs(() => ({
    className: String('ap-popup-close-icon')
}))`
    position: absolute;
    top: -8px;
    right: -12px;
    opacity: 0.7;
    ${Icon} {
        fill: ${({ theme: { popup: { colors } } }) => colors.popupCloseIconColor};
    }
`;

class PopupHeaderBase extends React.Component<IPopupHeaderProps> {
    render() {
        const { className, elementRef } = this.props;
        return (
            <div className={className} ref={elementRef}>
                {this.renderTitle()}
                {this.renderCloseButton()}
            </div>
        );
    }

    private renderTitle() {
        const { title, titleAlignment, onRenderTitle } = this.props;
        if (onRenderTitle !== undefined) {
            return onRenderTitle();
        }

        return title ? (
            <Title titleAlignment={titleAlignment}>
                {title}
            </Title>
        ) : null;
    }

    private renderCloseButton() {
        const { hideCloseButton, onCloseClick } = this.props;
        return hideCloseButton ? null : (
            <CloseAction
                onClick={onCloseClick}
                size="small"
                iconName="ap-close2.outline"
                iconSize="16"
                title="Close"
            />
        );
    }
}

export const PopupHeader = styled(PopupHeaderBase).attrs(() => ({
    className: String('ap-popup-header-wrapper')
}))`
    display: block;
    position: relative;
    width: 100%;
    min-height: 24px;
    height: auto;
    flex: none;
`;
